import { getCustomBrowseItemsByGuideId } from './browse';

export const FETCH_PAYMENT_COMPLETION_ITEMS = 'FETCH_PAYMENT_COMPLETION_ITEMS';

export function getPaymentCompletionPageItems(guideId) {
  return getCustomBrowseItemsByGuideId(guideId, FETCH_PAYMENT_COMPLETION_ITEMS);
}
